import cx from "classnames";
import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { StatusCircleCheckmark } from "@gaming/xds-react-js-icons";

import { useProgramBackgroundColorPicker } from "../../../helpers/useProgramColorPicker";
import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./CheckMarkIcon.module.css";

export const CheckMarkIcon = () => {
  const colorStyle = useProgramBackgroundColorPicker();
  const [checkmarkIcon] = useStrings("checkmarkIcon");

  return (
    <Icon
      title={checkmarkIcon}
      className={cx(styles.checkMarkIcon, colorStyle)}
      icon={StatusCircleCheckmark}
      iconSize={IconSize.Custom}
    />
  );
};
